export default __webpack_public_path__ + "static/media/whatsapp.7470d45f.svg";